import { NgModule } from '@angular/core'
import { CommonModule } from '@angular/common';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { IonicModule } from '@ionic/angular';
// SharedModule removed to avoid circular dependency in demo
import { HealthScoreGuageComponent } from './health-score-guage.component';
import { NgApexchartsModule } from 'ng-apexcharts';

@NgModule({
  imports: [
    CommonModule,
    FormsModule,
    ReactiveFormsModule,
    IonicModule,
    NgApexchartsModule,
    
  ],
  declarations: [HealthScoreGuageComponent],
  exports: [HealthScoreGuageComponent],
})
export class HealthScoreGuageModule {}


